import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export const useContactUsCMSData = () => {
    const { t } = useTranslation('contact_us_V2_page');

    const data = useMemo(
        () => ({
            data: {
                ContactUsPage: {
                    title: t('contact_us_V2_page:contact_us'),
                    subheading: t('contact_us_V2_page:subheading'),
                    makeReservationBtn: t('contact_us_V2_page:make_reservation_btn'),
                    callUs: t('contact_us_V2_page:call_us'),
                    mailUs: t('contact_us_V2_page:mail_us'),
                    corporateHeadquarters: t('contact_us_V2_page:corporate_headquarters'),
                    addressLine1: t('contact_us_V2_page:address_line_1'),
                    addressLine2: t('contact_us_V2_page:address_line_2'),
                    addressCountry: t('contact_us_V2_page:usa_label'),
                    usaPhoneLabel: t('contact_us_V2_page:usa_label'),
                    internationalPhoneLabel: t('contact_us_V2_page:international_phone_label'),
                    yourDetails: t('contact_us_V2_page:your_details'),
                    firstName: t('contact_us_V2_page:first_name'),
                    lastName: t('contact_us_V2_page:last_name'),
                    email: t('contact_us_V2_page:email'),
                    phoneNumber: t('contact_us_V2_page:phone_number'),
                    country: t('contact_us_V2_page:country'),
                    message: t('contact_us_V2_page:message'),
                    product: t('contact_us_V2_page:product'),
                    reason: t('contact_us_V2_page:reason'),
                    reservationNumber: t('contact_us_V2_page:reservation_number'),
                    messagePlaceholder: t('contact_us_V2_page:message_placeholder'),
                    privacyPolicyText: t('contact_us_V2_page:privacy_policy_text'),
                    privacyPolicyLink: t('contact_us_V2_page:privacy_policy_link'),
                    sendButton: t('contact_us_V2_page:send_button'),
                    additionalInformationTitle: t(
                        'contact_us_V2_page:additional_information',
                    ),
                    damageWaiverLink: t('contact_us_V2_page:info_links.damage_waiver'),
                    driverLicenseRequirementsLink: t(
                        'contact_us_V2_page:info_links.driver_license_requirements',
                    ),
                    faqsLink: t('contact_us_V2_page:info_links.faqs'),
                    paymentOptionsLink: t(
                        'contact_us_V2_page:info_links.payment_options',
                    ),
                    rentalTermsLink: t('contact_us_V2_page:info_links.rental_terms'),
                    guidedToursTermsLink: t(
                        'contact_us_V2_page:info_links.guided_tours_terms',
                    ),
                    selfGuidedTermsLink: t(
                        'contact_us_V2_page:info_links.self_guided_terms',
                    ),
                    offRoadTermsLink: t('contact_us_V2_page:info_links.off_road_terms'),
                    membershipTermsLink: t(
                        'contact_us_V2_page:info_links.membership_terms',
                    ),
                    patternBackground: {
                        sizes: {
                            small_url: {
                                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
                            },
                            medium_url: {
                                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
                            },
                            large_url: {
                                url: '/imgs/Rebranding/petterns/asphalt.png',
                            },
                        },
                        alt: t('contact_us_V2_page:pattern_background_alt'),
                    },
                },
                NewMainWidgetComponent: {
                    rentMotorcycle: t('common_new_main_widget:rent_motorcycle'),
                    allMotorcycleTours: t('common_new_main_widget:all_motorcycle_tours'),
                    guidedMotorcycleTours: t('common_new_main_widget:guided_motorcycle_tours'),
                    selfDriveMotorcycleTours: t('common_new_main_widget:self_drive_motorcycle_tours'),
                    returnToSameLocation: t('common_new_main_widget:return_to_same_location'),
                    searchTour: t('common_new_main_widget:search_tour'),
                    tourTypeLabel: t('common_new_main_widget:tour_type'),
                    countryLabel: t('common_new_main_widget:country_label'),
                    stateNameLabel: t('common_new_main_widget:state_name_label'),
                    tourTabLabel: t('common_new_main_widget:tour_tab_label'),
                    rentalTabLabel: t('common_new_main_widget:rental_tab_label'),
                    country: t('common_new_main_widget:country'),
                    stateName: t('common_new_main_widget:state_name'),
                    futureBookings: t('common_new_main_widget:future_bookings'),
                    saveEvenMore: t('common_new_main_widget:save_even_more'),
                    rideRoundTripOrOneWay: t('common_new_main_widget:can_ride_rounded_trip_or_one_way'),
                    startYourReservation: t('common_new_main_widget:start_your_reservation'),
                    pickupLocation: t('common_new_main_widget:pickup_location'),
                    choosePickupLocation: t('common_new_main_widget:choose_pickup_location'),
                    dropoffLocation: t('common_new_main_widget:dropoff_location'),
                    chooseDropoffLocation: t('common_new_main_widget:choose_dropoff_location'),
                    sameAsPickupLocation: t('common_new_main_widget:same_as_pickup_location'),
                    dropoffLocationError: t('common_new_main_widget:dropoff_location_error'),
                    pickupDateLabel: t('common_new_main_widget:pickup_date_label'),
                    dropoffDateLabel: t('common_new_main_widget:dropoff_date_label'),
                    milesAway: t('common_new_main_widget:miles_away'),
                    baseErrorHeader: t('common_new_main_widget:base_error_header'),
                    warning: t('common_new_main_widget:warning'),
                    warningNote: t('common_new_main_widget:warning_note'),
                    saveUpTo: t('common_new_main_widget:save_up_to'),
                    closedAlertText: t('common_new_main_widget:closed_alert'),
                    timeLabel: t('common_new_main_widget:time'),
                    reserveBtnLabel: t('common_new_main_widget:reserve'),
                    vehiclesLabel: t('common_new_main_widget:vehicles'),
                },
                MainWidgetDialogComponent: {
                    startYourAdventureLabel: t('common_main_widget_dialog_v2:start_your_adventure'),
                },
                FormSection: {
                    yourDetails: t('contact_us_V2_page:your_details'),
                    firstName: t('contact_us_V2_page:first_name'),
                    lastName: t('contact_us_V2_page:last_name'),
                    email: t('contact_us_V2_page:email'),
                    phoneNumber: t('contact_us_V2_page:phone_number'),
                    country: t('contact_us_V2_page:country'),
                    message: t('contact_us_V2_page:message'),
                    product: t('contact_us_V2_page:product'),
                    reason: t('contact_us_V2_page:reason'),
                    reservationNumber: t('contact_us_V2_page:reservation_number'),
                    messagePlaceholder: t('contact_us_V2_page:message_placeholder'),
                    readAgreed: t('contact_us_V2_page:read_agreed'),
                    erPrivacyPolicy: t('contact_us_V2_page:er_privacy_policy'),
                    sendButton: t('contact_us_V2_page:send_button'),
                    erReadTermsAndConditions: t('contact_us_V2_page:er_read_terms_and_conditions'),
                    successMsg: t('contact_us_V2_page:success_msg'),
                },
            },
        }),
        [t],
    );

    return data;
};

